import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import * as i18n from "../common/i18n";
import MaterialTable from 'material-table'
import { reactLocalStorage } from 'reactjs-localstorage';

import gql from 'graphql-tag';
import Message from "./Message";
import * as graphql from '../common/graphql';
import * as helper from "../common/helper";
import moment from "moment";
import Chip from '@material-ui/core/Chip';
import RouterIcon from '@material-ui/icons/Router';

import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";
import ReloadIcon from '@material-ui/icons/Replay';

const styles = theme => ({
});


const defaults = {
    id: true,
    device: false,
    firmware: false,
    created: false,
    rh: false,
    pageSize: 20,
};

const defaultsPropertyName = 'p71.syncs.defaults';

class Syncs extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            userSettings: reactLocalStorage.getObject(defaultsPropertyName, defaults),
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(defaultsPropertyName, newUserSettings);
        });
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    mapField(column) {
        switch (column) {
            case "device":
                return "uuid"
            default:
                return column;
        }
    }

    render() {

        return (
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization()}
                    columns={[
                        {
                            title: i18n.get("syncs.id"),
                            field: 'id',
                            hidden: this.default("id"),
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            sorting: false,
                            filtering: false
                        },
                        {
                            title: i18n.get("syncs.device"),
                            field: 'device',
                            hidden: this.default("device"),
                            cellStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            headerStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            sorting: true,
                            filtering: true,
                            customSort: () => 0,
                            render: rowData => {
                                return rowData && rowData.device ? <Chip label={rowData.device.uuid} icon={<RouterIcon />} /> : null
                            }
                        },
                        {
                            title: i18n.get("syncs.firmware"),
                            field: 'firmware',
                            hidden: this.default("firmware"),
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("syncs.rh"),
                            field: 'rh',
                            hidden: this.default("rh"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            render: rowData => {
                                if (rowData) {
                                    return rowData.rh ? `${rowData.rh} %` : '';
                                } else {
                                    return ''
                                }
                            },
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("syncs.temperature"),
                            field: 'temperature',
                            hidden: this.default("temperature"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            filterComponent: helper.RangeFilter,
                            type: "numeric",
                            render: rowData => {
                                if (rowData) {
                                    return rowData.temperature ? `${rowData.temperature} C` : '';
                                } else {
                                    return ''
                                }
                            },
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("syncs.pressure"),
                            field: 'pressure',
                            hidden: this.default("pressure"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            type: "boolean",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("syncs.created"),
                            field: 'created',
                            hidden: this.default("created"),
                            type: "datetime",
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            filterComponent: helper.DateRangeFilter,
                            sorting: true,
                            filtering: true
                        }

                    ]}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {


                                const where = helper.whereString(query["filters"], this.mapField, ["uuid"]);
                                const orderBy = helper.orderByString(query, this.mapField, "created", query["orderBy"] && query["orderBy"]["field"] === "device");
                                if (query["orderBy"] && query["orderBy"]["field"] === "device" && where === "[]") {
                                    where = '[{column: "created", comparator: GT, datetime: -1}]'
                                }
                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        syncs(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                                ... on Sync {
                                                    id,
                                                    device {uuid}
                                                    firmware
                                                    created {X}
                                                    rh
                                                    temperature
                                                    pressure
                                               }
                                            }
                                        }
                                    }
                                `,
                                    fetchPolicy: "no-cache"
                                });

                                const searchResult = {
                                    page: query.page,
                                    data: result.data.syncs.elements.map(
                                        (element) => {
                                            return {
                                                id: element.id,
                                                device: element.device,
                                                firmware: element.firmware,
                                                created: element.created ? moment(element.created.X, 'X').toDate() : null,
                                                rh: element.rh,
                                                temperature: element.temperature,
                                                pressure: element.pressure,
                                            };
                                        }),
                                    totalCount: result.data.syncs.totalCount
                                }

                                resolve(searchResult);
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }
                    actions={[{
                        isFreeAction: true,
                        icon: () => { return <ReloadIcon /> },
                        tooltip: i18n.get("general.reload"),
                        onClick: async (event, rowData) => {
                            this.tableRef.current.onQueryChange();
                        }
                    }]}
                    title={i18n.get("journals.title")}
                    options={{
                        addRowPosition: "first",
                        exportButton: false,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 500,
                        search: false,
                        columnsButton: true,
                        pageSize: this.default("pageSize"),
                        pageSizeOptions: [5, 20, 50]
                    }}
                />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />
            </div>
        )
    }
}

Syncs.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(Syncs))